import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';
import { List } from 'lodash';

interface GeneralInfoState {
    CentralVer?:string,
    SQLVersion?:string,
    DsSQLBackupInfo:List<JSON>,
    DreamLabSendInfo:List<JSON>,
    ParsicMasterInfo:any,
    MyParsicServiceLog:any,
    hostname?:string,
    IISIpAddress:string,
    SQLServerIP:string,
    SMSRemainingCredit:string,
    SqlServerName:string,
    OsInfo:List<JSON>,
    WordVersion:string,
    ParsicTempAccess:List<JSON>,
    GoogleConnection:boolean,
    ParsiPolServiceConnection:boolean,
    SqlConnection:boolean,
    PadvishIsRunning:boolean,
    PadvishIsInstalled:boolean,
    SQLIsInstalled:boolean,
    PrintCatcherIsInstalled:boolean,
    PwebserviceUserInSql:boolean,
    SqlIPPing:boolean,
    SqlRemotControlPort:boolean,
    CheckParsicSMSServiceStatus:boolean,
    LastAutoBackupForLastWeek:boolean,
    InetsrvLogFolderIsExist:boolean,

}
  
const initialState:GeneralInfoState = {
    CentralVer:"",
    SQLVersion:"",
    DsSQLBackupInfo:[],
    DreamLabSendInfo:[],
    ParsicMasterInfo:[],
    MyParsicServiceLog:[],
    hostname:"",
    IISIpAddress:"",
    SQLServerIP:"",
    SMSRemainingCredit:"",
    SqlServerName:"",
    OsInfo:[],
    WordVersion:"",
    ParsicTempAccess:[],
    GoogleConnection:false,
    ParsiPolServiceConnection:false,
    SqlConnection:false,
    PadvishIsRunning:false,
    PadvishIsInstalled:false,
    SQLIsInstalled:false,
    PrintCatcherIsInstalled:false,
    PwebserviceUserInSql:false,
    SqlIPPing:false,
    SqlRemotControlPort:false,
    CheckParsicSMSServiceStatus:false,
    LastAutoBackupForLastWeek:false,
    InetsrvLogFolderIsExist:false,
}

export const GeneralInfoSlice = createSlice({
    name:"generalInfo",
    initialState,
    reducers:{
        UpdateGeneralInfo: (state,action) => {
            state.CentralVer= action.payload.CentralVer;
            state.SQLVersion= action.payload.SQLVersion;
            state.DsSQLBackupInfo = action.payload.DsSQLBackupInfo;
            state.DreamLabSendInfo= action.payload.DreamLabSendInfo;
            state.ParsicMasterInfo= action.payload.ParsicMasterInfo;
            state.MyParsicServiceLog= action.payload.MyParsicServiceLog;
            state.hostname= action.payload.hostname;
            state.IISIpAddress= action.payload.IISIpAddress;
            state.SQLServerIP= action.payload.SQLServerIP;
            state.SMSRemainingCredit= action.payload.SMSRemainingCredit;
            state.SqlServerName= action.payload.SqlServerName;
            state.OsInfo= action.payload.OsInfo;
            state.WordVersion= action.payload.WordVersion;
            state.ParsicTempAccess= action.payload.ParsicTempAccess;
            state.GoogleConnection= action.payload.GoogleConnection;
            state.ParsiPolServiceConnection= action.payload.ParsiPolServiceConnection;
            state.SqlConnection= action.payload.SqlConnection;
            state.PadvishIsRunning= action.payload.PadvishIsRunning;
            state.PadvishIsInstalled= action.payload.PadvishIsInstalled;
            state.SQLIsInstalled= action.payload.SQLIsInstalled;
            state.PrintCatcherIsInstalled= action.payload.PrintCatcherIsInstalled;
            state.PwebserviceUserInSql= action.payload.PwebserviceUserInSql;
            state.SqlIPPing= action.payload.SqlIPPing;
            state.SqlRemotControlPort= action.payload.SqlRemotControlPort;
            state.CheckParsicSMSServiceStatus= action.payload.CheckParsicSMSServiceStatus;
            state.LastAutoBackupForLastWeek= action.payload.LastAutoBackupForLastWeek;
            state.InetsrvLogFolderIsExist= action.payload.InetsrvLogFolderIsExist;

        },
        AddGeneralInfo: (state,action) => (
            initialState
        ),
        EditGeneralInfo: (state,action) => (
            initialState
        ),
        RemoveGeneralInfo: (state,action) => (
            initialState
            )
    }
})

export const {UpdateGeneralInfo,AddGeneralInfo,EditGeneralInfo,RemoveGeneralInfo} = GeneralInfoSlice.actions

export const selectGeneralInfo = (state: RootState) => state.generalInfo

export default GeneralInfoSlice.reducer;